// utils/dateUtils.js
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Converts a date to a timestamp at midnight in the user's local timezone.
 * @param {Date | string} date - The selected date (Date object or ISO string)
 * @param {string} [tz] - Optional timezone, e.g., "Asia/Kuala_Lumpur"
 * @returns {number} Unix timestamp in milliseconds
 */
export const getLocalMidnightTimestamp = (date, tz) => {
  const userTimeZone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;

  return dayjs(date).tz(userTimeZone).endOf('day').valueOf();
};
